<template>
  <table class="product-variants">
    <thead class="product-variants__sticky product-variants__sticky--heading">
      <tr>
        <th :class="['product-variants__sticky product-variants__sticky--left']">
          <div class="product-variant__head-inset" :title="tStatic('tableHeaderVariantArtNo')">
            <span>
              {{ tStatic('tableHeaderVariantArtNo') }}
            </span>

            <oie-table-sort-actions v-if="mq('medium')" :path="'id'" :product-id="product.id"></oie-table-sort-actions>
          </div>
        </th>

        <th v-for="(value, key) in getSpecification()" :key="`table-header-${key}`">
          <div class="product-variant__head-inset" :title="value.display">
            <span>
              {{ value.display }}
            </span>

            <oie-table-sort-actions v-if="mq('medium')" :path="value.path" :product-id="product.id"></oie-table-sort-actions>
          </div>
        </th>

        <th class="product-variant__head-stock product-variants__sticky product-variants__sticky--right-fixed">
          <div class="product-variant__head-inset" :title="tStatic('tableHeaderVariantStock')">
            <span>{{ tStatic('tableHeaderVariantStock') }}</span>

            <oie-table-sort-actions v-if="mq('medium')" :product-id="product.id"></oie-table-sort-actions>
          </div>
        </th>

        <th class=" product-variant__head-price-action product-variants__sticky product-variants__sticky--right">
          <div class=" product-variant__head-price-action product-variant__head-inset">
            <span>{{ tStatic('tableHeaderVariantPrice') }}</span>

            <oie-table-sort-actions v-if="mq('medium')" :product-id="product.id"></oie-table-sort-actions>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <template v-for="(item, row) in items">
        <tr
          v-show="showRow(item)"
          :key="`table-row-${row}`"
          :class="['product-variants__row--url', { 'product-variants__row--is-selected': item.id == clientModel.selectedItem, 'product-variants__row--is-search-selected': item.selected }]"
          @click="goToUrl(item)">
          <td :class="['product-variants__sticky product-variants__sticky--left', {'product-variants--shadow-right': applyArticleNumberShadow}]">
            <div v-if="mq('to-medium')" class="product-variant__body-header">
              {{ tStatic('tableHeaderVariantArtNo') }}
            </div>

            <div class="product-variant__body-inset product-variant__body-inset--article">
              <div class="product-variant__article-number">
                <span class="product-variant__article-name">{{ tStatic('tableRowVariantArtNo') }}</span> {{ item.id }}
              </div>
            </div>
          </td>

          <td v-for="(value, cell) in getValues(item)" :key="`table-body-${row}-${cell}`">
            <div v-if="mq('to-medium')" class="product-variant__body-header">
              {{ keys[cell] }}
            </div>

            <div class="product-variant__body-inset">
              <span v-html="value"></span>
            </div>
          </td>

          <td :class="['product-variants__sticky product-variants__sticky--right-fixed', {'product-variants--shadow-left': applyStockPriceShadow}]" :style="`z-index: ${getZIndex(row)}`">
            <div v-if="mq('to-medium')" class="product-variant__body-header">
              {{ tStatic('tableHeaderVariantStock') }}
            </div>

            <oie-product-status
              v-if="!isQuoteItem(item) && !isExpiredItem(item)"
              :status="getStockStatus(item.stock, item.isOrderItem)"
              :text="getStockMessage(item.stock, item.isOrderItem)"
              classes="product-variant__body-inset">
            </oie-product-status>
          </td>

          <td class="product-variants__sticky product-variants__sticky--right" :style="`z-index: ${getZIndex(row)}`">
            <div v-if="isInternalItem(item) && !mq('to-medium')" class="product-variant__body-inset">
              <p class="caption product-variant__internal">
                <oie-base-icon icon="warning"></oie-base-icon>
                <span v-html="tStatic('internalItemContent')"></span>
              </p>
            </div>
            <div class="product-variant__body-inset product-variant__body-inset--price-action">
              <p
                v-if="isExpiredItem(item)"
                class="caption product-variant__expired">
                <oie-base-icon icon="warning"></oie-base-icon>
                <span v-html="tStatic('expiredItemContent')"></span>
              </p>
              <p
                v-else-if="isQuoteItem(item)"
                class="caption product-variant__quote-info"
                v-html="tStatic('requestQuoteContent')"></p>

              <p v-else-if="isInternalItem(item) && mq('to-medium')" class="caption product-variant__internal">
                <oie-base-icon icon="warning"></oie-base-icon>
                <span v-html="tStatic('internalItemContent')"></span>
              </p>

              <oie-product-price v-else :current-object="item" :is-product="false"></oie-product-price>

              <div v-if="!isExpiredItem(item)" class="product-variant__button-container">
                <oie-request-quote-slide-in v-if="isQuoteItem(item)" :item-id="item.id"></oie-request-quote-slide-in>

                <oie-base-action
                  v-else
                  :disabled="hasNoPrice(item)"
                  size="large"
                  theme="secondary"
                  @click.stop="addItemToCart(item)">
                  {{ tStatic('addToCartButtonLabel') }}
                </oie-base-action>

                <oie-add-to-shopping-list-slide-in :product="{...product, items: [item]}"></oie-add-to-shopping-list-slide-in>

                <oie-notify-me-slide-in
                  v-if="showNotifyMe(item)"
                  :article-number="item.id"
                  :article-name="`${product.name} ${currentVehicle ? ', ' + currentVehicle.brand + ' ' + currentVehicle.displayName : ''}`">
                </oie-notify-me-slide-in>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import utils from '@/core/utils'
import gtm from '@/core/enhanced-ecommerce-gtm'
import { productStatuses } from '@/variables/product-statuses'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    productId: {
      type: String,
      default: ''
    },
    typeOfListing: {
      type: String,
      default: ''
    },
    isSearchPage: {
      type: Boolean,
      default: false
    },
    applyArticleNumberShadow: {
      type: Boolean,
      default: false
    },
    applyStockPriceShadow: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    values: [],
    specification: [],
    sortBy: '',
    sortOrder: '',
    prices: [],
    list: []
  }),
  computed: {
    ...mapGetters(['enableGtm', 'enableArticleWatch', 'currentVehicle']),
    ...mapGetters('productVariants', ['displayAllVariants']),
    items: function() {
      return _.orderBy(this.product.items, (item) => {
        if (this.sortBy === '') { return item.sortOrder }
        return !this.sortBy ? item.id : item.specification[this.sortBy][1].toLowerCase()
      }, this.sortOrder)
    },
    keys() {
      return _.map(this.product.items[0].specification, i => i[0])
    },
    getRouteCode() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      if(params.get('category') !== null) {
        return params.get('category')
      }

      return ''
    },
    getRouteVehicle() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      if(params.get('currentVehicle') !== null) {
        return params.get('currentVehicle')
      }
      if(params.get('code') !== null) {
        return params.get('code')
      }

      return ''
    }
  },
  mounted() {
    if(this.productId !== '') {
      this.subscribe('sort' + this.productId, (path, order) => {
        this.sortBy = path.split('.')[1]
        this.sortOrder = order
      })
    } else {
      this.subscribe('sort' + this.product.id, (path, order) => {
        this.sortBy = path.split('.')[1]
        this.sortOrder = order
      })
    }
  },
  methods: {
    ...mapActions('commerce', ['addToCart']),
    showRow(item) {
      if(this.isSearchPage) {
        return item.selected || this.displayAllVariants(this.product.id)
      } else {
        return true
      }
    },
    getSpecification() {
      if(this.product.items === undefined) {
        return {}
      }
      const itemsSpecifications = _.get(this.product.items[0], 'specification')
      return this.createKeys(itemsSpecifications)
    },
    getValues(item) {
      return _.map(item.specification, i => i[1])
    },
    getCellValue(item) {
      const name = item.split('')
        .map(a => a === '[' ? '' : a === ']' ? '' : a === ';' ? ',\r\n' : a)
        .join('')
      return name
    },
    createKeys(specification) {
      var list = []
      _.forEach(specification, (item, index) => {
        var tKey = item[0]
        list.push({ path: 'specification.' + index + '.' + tKey, display: tKey })
      })
      return list
    },
    getStockStatus(number, isOrderItem) {
      var threshold = this.getProductFewInStock()
      if (number === undefined) { number = 0 }
      if (threshold === undefined) { threshold = 0 }
      if(number >= threshold) {
        return 'in-stock'
      }else if(number > 0) {
        return 'few-stock'
      } else if(isOrderItem) {
        return 'is-order-item'
      }else{
        return 'no-stock'
      }
    },
    getStockMessage(number, isOrderItem) {
      var inStockMessage = this.tStatic('stockAvailableLabel')
      var fewStockMessage = this.tStatic('stockFewLabel')
      var noStockMessage = this.tStatic('stockNoneLabel')
      var isOrderItemStockMessage = this.tStatic('stockIsOrderItemLabel')
      var threshold = this.getProductFewInStock()

      if (number === undefined) {
        number = 0
      }

      if (threshold === undefined) {
        threshold = 0
      }

      if (number >= threshold) {
        return inStockMessage
      } else if (number > 0) {
        return fewStockMessage
      } else if (isOrderItem) {
        return isOrderItemStockMessage
      } else {
        return noStockMessage
      }
    },
    hasNoPrice(item) {
      return !item.customerPrice
    },
    isQuoteItem(item) {
      return item.publicationStatusCode === productStatuses.noPrice || false
    },
    isExpiredItem(item) {
      return item.publicationStatusCode === productStatuses.expired || false
    },
    isInternalItem(item) {
      return item.publicationStatusCode === productStatuses.internal || false
    },
    addItemToCart(item) {
      this.addToCart({ itemId: item.id, productId: this.product.id, purchasedOnCategory: this.clientModel.analyticsCategory, purchasedToVehicle: this.clientModel.analyticsVehicle }).then((data) => {
        if (this.enableGtm && data.cart) {
          const addedProduct = data.cart.rows.find((x => x.itemId === item.id) && (x => x.productId === this.product.id))

          const gtmObject = gtm.createGtmItem(
            addedProduct.itemId,
            addedProduct.displayName,
            addedProduct.item.purchasedToVehicle,
            addedProduct.item.purchasedOnCategory,
            this.formatPriceWithoutCurrency(addedProduct.priceExVat),
            1, // quantity
            this.typeOfListing)

          gtm.addToCart(gtmObject)
        }
      })
    },
    getUrlBasedOnLocation(item) {
      var currentLocation = window.location.pathname

      if (currentLocation.endsWith('/')) {
        currentLocation = currentLocation.slice(0, -1)
      }

      var pathArray = currentLocation.split('/')
      var newPathname = ''

      var levels = 2
      if(this.typeOfListing === 'Product listing' || !this.clientModel.selectedItem) {
        levels = 1
      }
      for (var i = 3; i < pathArray.length - levels; i++) {
        newPathname += '/'
        newPathname += pathArray[i]
      }
      if(pathArray[3] === 'product') {
        return `/${this.clientModel.currentMarket}/${this.clientModel.currentLanguage}${newPathname}/${item.id}/${this.product.id}`
        // return '/' + this.clientModel.currentMarket + '/' + this.clientModel.currentLanguage + newPathname + '/' + item.id + '/' + this.product.id
      }else {
        return `/${this.clientModel.currentMarket}/${this.clientModel.currentLanguage}/product${newPathname}/${item.id}/${this.product.id}`
        // return '/' + this.clientModel.currentMarket + '/' + this.clientModel.currentLanguage + '/product' + newPathname + '/' + item.id + '/' + this.product.id
      }
    },
    goToUrl(item) {
      var currentVehicle = null
      if(this.product.currentVehicle !== null) {
        currentVehicle = this.product.currentVehicle
      }
      if(this.getRouteVehicle != null) {
        currentVehicle = this.getRouteVehicle
      }
      if(currentVehicle) {
        const selectedFractions = utils.getQueryStringParam('f')
        const selectedFractionsQueryParam = selectedFractions ? `&f=${encodeURIComponent(selectedFractions)}` : ''
        if(currentVehicle !== this.getRouteCode) {
          window.location.href = this.getUrlBasedOnLocation(item) + '?currentVehicle=' + currentVehicle + '&category=' + this.getRouteCode + selectedFractionsQueryParam
        }else {
          window.location.href = this.getUrlBasedOnLocation(item) + '?currentVehicle=' + currentVehicle + selectedFractionsQueryParam
        }
      }else{
      // window.location.href = item.url
        window.location.href = this.getUrlBasedOnLocation(item)
      }
    },
    showNotifyMe(item) {
      return this.enableArticleWatch && this.getStockStatus(item.stock, item.isOrderItem) === 'no-stock' && item.id !== this.clientModel.selectedItem
    },
    getZIndex(row) {
      return this.items.length - row
    }
  }
}
</script>

<style lang="scss">
.product-variants {
  display: block;
  width: 100%;
  position: relative;
  white-space: nowrap;

  @include media(medium) {
    height: 1px;
    display: table;
    border: none;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid color(border-gray);
  }
}

.grid--list .product-variants {
  @include media(medium) {
    border-top: 0;
  }
}

.product-variants thead {
  display: none;

  @include media(medium) {
    display: table-header-group;
  }
}

.product-variants tbody,
.product-variants tbody tr {
  @include media(to-medium) {
    display: block;
    width: 100%;
  }
}

.product-variants tbody tr {
  @include media(to-medium) {
    border-right: 1px solid color(border-gray);
    border-left: 1px solid color(border-gray);
    margin-bottom: measure(half);
    background-color: color(background-white);
  }
}

.product-variants th,
.product-variants td {
  margin: 0;
  padding: 0;
  background-color: color(background-blue-6);
}

.product-variants td {
  display: flex;
  border: 1px solid color(border-gray);

  @include media(to-medium) {
    border-bottom: 1px solid color(border-gray);
  }

  @include media(medium) {
    display: table-cell;
    min-height: 6.25rem;
  }
}

.product-variants tbody tr {
  height: 100%;
  border-top: 1px solid color(border-gray);

  &:hover {
    background-color: color(background-light-green);
  }
}

.product-variants tr td:not(:last-child) {
  @include media(medium) {
    border-right: 1px solid color(border-gray);
  }
}

.product-variants tbody tr.product-variants__row--is-search-selected td {
  background-color: color(background-light-green);
}

.product-variants tr.product-variants__row--is-selected td {
  background-color: color(background-light-green);
  height: 100%;
}

.product-variants tr.product-variants__row--url {
  cursor: pointer;
}

.product-shell--show-variants thead tr th:first-child,
.product-shell--show-variants tr.product-variants__row--url td:first-child {
  padding-left: measure(quarter);
}

.product-variants tr.product-variants__row--is-selected td .product-variant__body-header,
.product-variants tr.product-variants__row--is-selected td .product-variant__body-inset--price-action {
  @include media(to-medium) {
    position: relative;
    height: 100%;

    &::before {
      content: '';
      position: absolute;
      top: -1px;
      bottom: -1px;
      left: -1px;
      width: 2px;
      background-color: color(button-action-green);
    }
  }
}

.product-variants tr.product-variants__row--is-selected td:first-child .product-variant__body-inset--article {
  @include media(medium) {
    position: relative;
    height: 100%;

    &::before {
      content: '';
      position: absolute;
      top: -1px;
      bottom: -1px;
      left: -1px;
      width: 2px;
      background-color: color(button-action-green);
    }
  }
}

.product-variant__head-inset {
  @include body-smaller;
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: measure(quarter) measure(full) measure(quarter) measure(quarter);
  height: 100%;
  flex-basis: 50%;
}

.product-variant__head-inset > span {
  pointer-events: none;
}

.product-variant__head-inset:hover .table-sort {
  opacity: 1;
  visibility: visible;
}

.product-variant__head-stock {
  width: 5.625rem;
}

.product-variant__head-price-action {
  width: 220px;
}

.product-variant__body-header {
  @include body-smaller-semi-bold;
  flex-basis: 50%;
  flex-shrink: 0;
  padding: measure(quarter);
  border-right: 1px solid color(border-gray);
}

.product-variant__body-inset {
  @include body-smaller;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: measure(quarter);
  height: 100%;

  @include media(to-small) {
    flex-shrink: 0;
    flex-basis: 50%;
  }
}

.product-variant__body-inset--article {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.product-variant__name {
  @include body-bold;
  color: color(text);
  text-decoration: none;
  margin: 0 0 measure(eighth) 0;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}

.product-variant__article-number {
  @include caption-bold;
  display: block;
  width: 100%;
  color: color(text-blue);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.product-variant__article-name {
  display: none;
}

.product-variant__button {
  margin-left: auto;
}

.product-variant__body-inset--price-action {
  gap: measure(quarter);
  @include media(to-medium) {
    flex-direction: column;
    align-items: flex-start;
    flex-basis: 100%;
    width: 100%;
  }
}

.product-variant__body-inset--price-action .product-variant__button {
  @include media(to-medium) {
    width: 100%;
    margin-left: 0;
  }
}

.product-variant__body-inset--price-action .product-price {
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}

.product-variant__button-container {
  display: flex;
  align-items: center;
  gap: measure(quarter);
  margin-left: auto;

  @include media(to-medium) {
    margin-left: unset;
    align-self: stretch;
  }
}

.product-variant__expired {
  display: flex;
  align-items: center;
  gap: measure(eighth);
  padding: measure(eighth);
  background-color: color(background-gray-4);
  border: 1px solid color(border-gray-2);
  flex-grow: 1;
}

.product-variant__internal {
  display: flex;
  align-items: center;
  gap: measure(eighth);
  padding: measure(eighth);
  background-color: color(superuser-secondary);
  border: 4px solid color(superuser-primary);
  flex-grow: 1;
}

.product-variant__quote-info {
  white-space: normal;
  max-width: 20rem;
}

// STYLING THE STICKY COLUMNS

.product-variants__sticky {
  position: sticky;
  z-index: 1;
}

.product-variants__sticky--heading {
  top: 0;
  z-index: 30;
}

.product-variants__sticky--left {
  left: 0;
}

.product-variants__sticky--right {
  right: 0;
}

.product-variants__sticky--right-fixed {
  right: 220px;
}

.product-variants--shadow-right {
 box-shadow: 5px 0 5px -2px rgba(0, 0, 0, 0.2);
}

.product-variants--shadow-left{
 box-shadow: -5px 0px 5px -2px rgba(0, 0, 0, 0.2);

}

.product-variant__body-inset em {
    background-color: #44B1FA;
    font-style: normal;
    color: white;
    padding: 0rem .1rem 0rem .05rem;
}

.product-variant__body-inset em.instant-result__complete_match {
    background-color: #006db6;
    padding: .15rem .4rem .15rem .4rem;
    border-radius: 2px;
}
</style>
